/* Ott-common */
import { Platform as AemPlatform } from '@dtvgo/aem-service';

/* Utils */
import { getDeviceInfo, isTitan } from './general';
import { MsToWaitOnReconnection, Platform, DrmKeySystem } from '../../constants';
import vkKeys from '../common/vkKeys';

function init() {}

export default {
  osName: 'TitanOS',
  platformName: 'Titan',
  isTitan: true,
  signupUrl: '/titan',
  appName: 'titan_tv',
  aemPlatform: AemPlatform.TITAN,
  isThisPlatform: isTitan,
  init,
  // App and device info
  getDeviceInfo,
  msToWaitOnReconnection: MsToWaitOnReconnection[Platform.TITAN],
  // Player related options
  isPlayreadyUtf8AndPlain: true,
  // DRM Preference
  drmKeySystem: DrmKeySystem.PLAYREADY,
  // Conviva
  npaw: {
    name: 'Titan',
  },
  // Key codes
  keyCodes: vkKeys,
  getAppVersion: () => '',
};
